import { h } from 'preact'
import { replaceFilter } from '../../js/modules/utilities.js'
import { useLayoutEffect } from 'preact/hooks'

export const MenuOse = ({ items, cachekey, pageId }) => {
   useLayoutEffect(() => {
      if (document.querySelectorAll('.menu-ose .active').length) {
         let activeItemOffsetLeft = document.querySelector('.menu-ose .active').offsetLeft - 10
         document.querySelector('.menu-ose').scroll({
            left: activeItemOffsetLeft,
            behavior: 'smooth',
         })
      }
   }, [])


   return (
      <ul id="slider-menu" class="menu-n-1 menu-ose" data-testid="bande-menu-ose" data-cache-key={cachekey}>
         {items.map(({ title, URL, image, analytics }, index) => {
            return (
               <li
                  class={`lien-composite menu-link ${getActiveItem(pageId) === title ? 'active' : ''}`}
                  data-testid={`menu-ose${index}`}
                  data-oevent-category={analytics.oeventCategory}
                  data-oevent-action={analytics.oeventAction}
                  data-oevent-label={analytics.oeventLabel}
                  data-oevent-other={analytics.oeventOther}
               >
                  <img loading="lazy" class="hpicon" src={image} alt="" />
                  {getActiveItem(pageId) === title ? (
                     <h1 class="title" dangerouslySetInnerHTML={{ __html: replaceFilter(title) }}></h1>
                  ) : (
                     <a href={URL} class="title" dangerouslySetInnerHTML={{ __html: replaceFilter(title) }}></a>
                  )}
               </li>
            )
         })}
      </ul>
   )
}

const getActiveItem = (pageId = '') => {
   let activeItem = ''
   switch (pageId) {
      case 'n1-forfaits-prospect':
      case 'n1-forfaits':
         activeItem = 'Mobiles et Forfaits'
         break
      case 'n1-tv-prospect':
      case 'n1-tv':
         activeItem = 'TV et divertissement'
         break
   }
   return activeItem
}
